import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-info-is-empty-list',
  templateUrl: './dialog-info-is-empty-list.component.html',
  styleUrls: ['./dialog-info-is-empty-list.component.css']
})
export class DialogInfoIsEmptyListComponent implements OnInit {

  constructor(
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

  onCloseDialog(): void {
    this.dialog.closeAll();
  }

}
